import { handleError } from "../../utils/Common/Constant";
import apiClient from "../Connection/Connection";

// Integration API
export const integrationsInfo = async (data: any) => {
  try {
    const res = await apiClient.post("/integrations/createApp", data);
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};

//Integration (get Applist API )
export const getIntegrations = async (
  currentPage: number,
  pageSize: number,
) => {
  try {
    const res = await apiClient.get(
      `/integrations/getIntegrations?currentPage=${currentPage}&pageSize=${pageSize}`,
    );
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};

//Integration (Detail Applist API )
export const getDetailsIntegrations = async (integrationId: string) => {
  try {
    const res = await apiClient.get(
      `/integrations/getIntegrationsDetails?integrationId=${integrationId}`,
    );
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};

// Integration (update integration details API)
export const updateIntegrationDetails = async (clientId: string, data: any) => {
  try {
    const res = await apiClient.put(
      `integrations/updateIntegration?clientId=${clientId}`,
      data,
    );
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};
// Integration (delete integration details API)
export const integrationDelete = async (clientId: string) => {
  try {
    const res = await apiClient.delete(
      `integrations/deleteIntegration?clientId=${clientId}`,
    );
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};

// Get staffAugmentation setttings details
export const staffAugSettingsDetails = async () => {
  try {
    const res = await apiClient.get(
      "/license/staffAugmentationSettingsDetails?lang=ar",
    );
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};

// staffAugmentationSettings api
export const staffAugAddSetting = async (data: any) => {
  try {
    const res = await apiClient.post(
      "/license/staffAugmentationSettings",
      data,
    );
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};

// delete staffAugmentationSettings Api
export const staffAugmSettingDelete = async (stage: string, title: string) => {
  try {
    const res = await apiClient.delete(
      `license/deleteStaffAugmentationSettings?stage=${stage}&title=${title}`,
    );
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};

// Edit setting api
export const updateStaffAugmSetting = async (data: any) => {
  try {
    const res = await apiClient.put(
      "/license/updateStaffAugumentationSettings",
      data,
    );
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};

// Review Documents approve reject
export const reviewDocuments = async (data: any) => {
  try {
    const response = await apiClient.post(
      "/partnerInvites/reviewDocuments",
      data,
    );
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};

// Approve Documents status API
export const approveDocStatus = async (data: any) => {
  try {
    const response = await apiClient.post("/contracts/startContract", data);
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};
